var _path, _ellipse, _path2, _path3, _circle, _circle2, _circle3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDatabaseHover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 5V15.5C3.5 16.88 6.4 18 10 18C13.6 18 16.5 16.88 16.5 15.5V5",
    fill: "url(#g2_dbs_h)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10,
    cy: 5,
    rx: 6.5,
    ry: 3,
    fill: "url(#g1_dbs_h)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 8.7C3.5 10.08 6.4 11.2 10 11.2C13.6 11.2 16.5 10.08 16.5 8.7",
    stroke: "white",
    strokeWidth: 1.3,
    fill: "none",
    opacity: 0.35
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 12.4C3.5 13.78 6.4 14.9 10 14.9C13.6 14.9 16.5 13.78 16.5 12.4",
    stroke: "white",
    strokeWidth: 1.3,
    fill: "none",
    opacity: 0.35
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.2,
    cy: 9.8,
    r: 0.45,
    fill: "white",
    opacity: 0.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 9.3,
    r: 0.45,
    fill: "white",
    opacity: 0.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.8,
    cy: 9.8,
    r: 0.45,
    fill: "white",
    opacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1_dbs_h",
    x1: 10,
    y1: 2,
    x2: 10,
    y2: 8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4E2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BA3F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g2_dbs_h",
    x1: 10,
    y1: 5,
    x2: 10,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDCEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4671F6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabaseHover);
export default __webpack_public_path__ + "static/media/database-hover.c3df9d531608fbfa23070cf8b64badfb.svg";
export { ForwardRef as ReactComponent };